import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

/**
 * I don't think we actually use this component right now, so for the time being,
 * we won't worry about specifying prop types and figuring out what from the
 * spread of `...rest` is actually necessary.
 */
/* eslint-disable */
export function Image({ id, url, ...rest }) {
  return (
    <ErrorBoundary name="image">
      <img key={id} src={url} {...rest} />
    </ErrorBoundary>
  );
}
